/**
 * TRIÁSICO — Aparición suave de los elementos [data-tr-reveal].
 * Sin dependencias. Respeta prefers-reduced-motion y no oculta nada si no hay JS.
 */
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function init() {
  if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  const viewportHeight = window.innerHeight;

  for (const element of document.querySelectorAll('[data-tr-reveal]')) {
    // Lo que ya está a la vista no se anima (evita parpadeos en la primera pantalla)
    if (element.getBoundingClientRect().top < viewportHeight) {
      element.classList.add('is-revealed');
    } else {
      observer.observe(element);
    }
  }

  document.documentElement.classList.add('tr-reveal-on');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
